import React, { memo } from "react";
import { Tag } from "antd";
import { colors } from "@/components/AlertWithBorder";
import { Inherited } from "./Icons";

const InheritedTag = () => {
  return (
    <Tag
      style={{
        borderWidth: "0px",
        borderRadius: "999px",
        backgroundColor: "#EFF4FF",
        margin: 0,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <span style={{ paddingLeft: "2px" }}>
          <Inherited />
        </span>
        <span
          style={{
            color: colors.info.main,
            padding: "4px",
          }}
        >
          Inherited
        </span>
      </div>
    </Tag>
  );
};

export default memo(InheritedTag);
